import EventEmitter from 'eventemitter3'

export const logoutEvent = new EventEmitter()
